
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/zapas/[id]",
      function () {
        return require("private-next-pages/zapas/[id].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/zapas/[id]"])
      });
    }
  